import { useEffect, useState } from 'react';

import { Toggle } from 'components/CheckboxToggle/types/Toggle';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import FrameHealthChart from 'features/Health/components/FrameHealthChart';
import { FrameHealthDimension } from 'features/Health/containers/FrameHealthChartContainer/types/frameHealthDimension';
import { getFilteredData } from 'features/Health/containers/FrameHealthChartContainer/utils/getFilteredData';
import useFetchWithToken from 'hooks/useFetchWithToken';
import { STATUS_API_URL } from 'utils/environmentVariables';
import { getActiveToggles } from 'utils/getActiveToggles';
import { toFiltersSearchParams } from 'utils/searchParamsConverter';

import useStyles from './FrameHealthChartContainer.styles';

type FrameHealthGraphProps = {
  frameHealthDimension: string;
  toggles: Toggle[];
};

const FrameHealthChartContainer = ({ frameHealthDimension, toggles }: FrameHealthGraphProps) => {
  const classes = useStyles();
  const [frameHealthData, setFrameHealthData] = useState<FrameHealthDimension[]>([]);
  const [frameHealthDimensions, setFrameHealthDimensions] = useState<FrameHealthDimension[]>([]);
  const { fetchDataWithToken } = useFetchWithToken();
  const { filters } = useFilters();

  useEffect(() => {
    const url = `${STATUS_API_URL}?by=${frameHealthDimension}`
      .concat('&')
      .concat(toFiltersSearchParams(filters).toString());
    fetchDataWithToken<FrameHealthDimension[]>(url, (data) => setFrameHealthDimensions(data));
  }, [filters]);

  useEffect(() => {
    if (frameHealthDimensions) {
      const activeToggles = getActiveToggles(toggles);
      setFrameHealthData(getFilteredData(frameHealthDimensions, activeToggles));
    }
  }, [frameHealthDimensions, toggles]);

  return (
    <div className={classes.root}>
      <FrameHealthChart
        chartId={frameHealthDimension}
        chartData={frameHealthData}
        frameHealthDimension={frameHealthDimension}
      />
    </div>
  );
};

export default FrameHealthChartContainer;
